import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import IconTimCard from 'components/icons/tims-card';

export default (props: IBaseProps) => <IconTimCard {...props} />;
